const ECG_PLOT_WIDTH = 4_710;

export { ECG_PLOT_WIDTH };
